import React, {useEffect, useRef, useState} from 'react';
import HeaderView from "./view";

export interface HeaderProps {
    dropdownButtonRef: React.RefObject<HTMLButtonElement>;
    dropdownMenuRef: React.RefObject<HTMLUListElement>;
    onDropdownToggle: () => void;
    onMenuItemClick: () => void;
    $isDarkMode: boolean;
    currentSection: string;
    buttonLabel: string;
    onLogoClick: () => void;
    onMoveEventSection:() => void;
    onMovePartnerSection:() => void;
}

interface HeaderComponentProps {
    currentSection: string;
    onLogoClick: () => void;
    onMoveEventSection:() => void;
    onMovePartnerSection:() => void;
}
function Header({ currentSection,onLogoClick,onMovePartnerSection,onMoveEventSection}: HeaderComponentProps) {
    const dropdownButtonRef = useRef<HTMLButtonElement>(null);
    const dropdownMenuRef = useRef<HTMLUListElement>(null);
    const [buttonLabel, setButtonLabel] = useState('앱 다운로드');

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1279) {
                setButtonLabel('다운로드');
            } else {
                setButtonLabel('앱 다운로드');
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const toggleDropdown = (isOpen: boolean) => {
        const dropdownMenu = dropdownMenuRef.current;
        if (dropdownMenu) {
            dropdownMenu.classList.toggle('show', isOpen);
        }
    };

    const onMenuItemClick = () => {
        toggleDropdown(false);
    };

    useEffect(() => {
        const dropdownMenu = dropdownMenuRef.current;

        const handleOutsideClick = (event: MouseEvent) => {
            if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                const target = event.target as Node;
                if (!dropdownButtonRef.current?.contains(target) && !dropdownMenu.contains(target)) {
                    toggleDropdown(false);
                }
            }
        };

        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && dropdownMenu?.classList.contains('show')) {
                toggleDropdown(false);
            }
        };

        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    const onDropdownToggle = () => {
        const dropdownMenu = dropdownMenuRef.current;
        if (dropdownMenu) {
            const isOpen = dropdownMenu.classList.contains('show');
            toggleDropdown(!isOpen);
            if (!isOpen) {
                const firstMenuItem = dropdownMenu.querySelector('li a');
                if (firstMenuItem instanceof HTMLElement) firstMenuItem.focus();
            }
        }
    };
    const $isDarkMode = currentSection === 'feedSection' || currentSection === 'partnerSection';

    const props: HeaderProps = {
        onDropdownToggle,
        onMenuItemClick,
        dropdownMenuRef,
        dropdownButtonRef,
        $isDarkMode,
        currentSection,
        buttonLabel,
        onLogoClick,
        onMovePartnerSection,
        onMoveEventSection,
    }

    return <HeaderView {...props} />
}

export default Header;
